
import { Component, computed, inject } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AnnouncementBannerComponent } from '@lb/components/announcement-banner/announcement-banner.component';
import { MDHeaderComponent } from '@melodic-ui/components';
import { SchedulerFormService } from '../../services/scheduler-form.service';
import { filter, startWith, switchMap } from 'rxjs';
import { ScheduleBaseCalendarComponent } from '../schedule-base-calendar/schedule-base-calendar.component';
import { SchedulerStateService } from '@lb/schedule/services/scheduler-state.service';

@Component({
	selector: 'lb-schedule-preferred-calendar',
	standalone: true,
	imports: [MDHeaderComponent, AnnouncementBannerComponent, ScheduleBaseCalendarComponent],
	templateUrl: './schedule-preferred-calendar.component.html',
	styleUrls: ['./schedule-preferred-calendar.component.scss']
})
export class SchedulePreferredCalendarComponent {
	private readonly _schedulerFormService = inject(SchedulerFormService);
	private readonly _scheduleStateService = inject(SchedulerStateService);

	public readonly formStep = 2;
	private readonly _scheduleFormSignal = toSignal(
		toObservable(this._schedulerFormService.step2Form).pipe(
			filter((form) => !!form),
			switchMap((form) => form.valueChanges.pipe(startWith(form.value)))
		),
		{ initialValue: undefined }
	);

	selectedSchedules = computed<string[]>(() => {
		const formValue = this._scheduleFormSignal();
		if (formValue) {
			return formValue.map((group: any) => group.id);
		}

		return [];
	});

	lessonsFrequency = computed(() => this._schedulerFormService.getFormData().configuration?.frequency || 0);
	disableCalendar = computed(() => this.selectedSchedules().length >= this.lessonsFrequency() * 2);

	isAdminScheduler = this._scheduleStateService.isAdmin;

	public clearSelection() {
		this._schedulerFormService.clearAllScheduleSelections(this.formStep);
	}

	public removeScheduleSelection(event: { scheduleID: string; step: number }) {
		this._schedulerFormService.removeScheduleSelection(event.scheduleID, event.step);
	}

	public addScheduleSelection(event: { scheduleData: { dayIndex: number; timeID: string }; step: number }) {
		this._schedulerFormService.addScheduleSelection(event.scheduleData, event.step);
	}
}
